export default "/_next/static/chunks/stacy.3f5b94be71e592ad24beddb122028a92.glb";